// pages/retail-investor/business-model.tsx
import type { ReactElement } from 'react'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { TitleLayout } from '@/components/layout'
import { CompanyLinks } from '@/components/layouts/Company/CompanyLinks'
import { Head } from '@/components/layouts/Head'

const BusinessModelPage = () => {
  return (
    <>
      <CompanyMain>
        <CompanyLinks padding={{ pc: '0 0', sp: '0 0' }} />
      </CompanyMain>
    </>
  )
}

export default BusinessModelPage

BusinessModelPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '個人投資家の皆様へ', path: '/ir/investor/' },
    { name: 'ビジネスモデル', path: '' },
  ];

  return (
    <>
      <Head
        title="企業情報"
        description="トライアルホールディングスの企業情報を掲載しています。"
        ogp={{ url: 'company/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        <BusinessSection>
          <BusinessTitle style={{ marginTop: '20px' }}>ビジネスモデル</BusinessTitle>
          <BusinessScription><span>●</span>リアル店舗の運営とリテールテックの開発を一体で推進</BusinessScription>
          <img style={{ marginTop: '30px' }} src="/images/business_model_0.png" />
          <BusinessRemark>*1 Every Day Low Price。毎日お値打ち価格で販売すること<br />*2 現場での実務を起点として、実際に現場で使用しながら機器やサービスを設計･運用し、改善を繰り返すことで、より現場のオペレーションに即したテクノロジーを開発するという当社グループの考え方</BusinessRemark>
          <BusinessImgTitle src="/images/business_model_73.png"></BusinessImgTitle>
          <img style={{ marginTop: '30px' }} src="/images/business_model_74.png" />
          <img style={{ marginTop: '12px' }} src="/images/business_model_25.png" />

          <BusinessMap>
            <img src="/images/business_model_40.png" />
          </BusinessMap>

          <BusinessImgTitle src="/images/business_model_30.png"></BusinessImgTitle>
          <BusinessScription><span>●</span>Smart Store Solution事業<br /><p>「リアル店舗×データ」で、顧客理解を深め、新時代のお買い物体験を創出。</p></BusinessScription>
          <img style={{ marginTop: '35px' }} src="/images/business_model_41.png" />
          <BusinessScription><span>●</span>Business Data事業<br /><p>全企業がデータ活用で消費者及びモノの流れを正しく理解し、業界全体の効率化と顧客体験の変革を実現。</p></BusinessScription>
          <img style={{ marginTop: '35px' }} src="/images/business_model_42.png" />
          <BusinessRemark>*1 Smart Store：Skip Cartやカメラ、インストアサイネージなどが導入され、データによる効率化がなされた店舗<br />*2 MD-Link：店舗運営に伴い蓄積されるデータをメーカーや卸と共有･分析するためのデータ分析基盤</BusinessRemark>

          <BusinessScription><span>●</span>自社開発のデータ基盤を活用したロイヤルカスタマー戦略</BusinessScription>
          <BusinessScription>
            <p style={{ fontSize: '18px', lineHeight: '30px', fontWeight: 'normal' }}>
              2025年９月に会員アプリ「トライアル＋(トライアルプラス)」のサービスを開始。「トライアル＋」では、会員限定価格のクーポンを発行するなど、新規会員の獲得や既存会員のロイヤルカスタマー化を推進。<br />
              「ワントゥワンマーケティング」の実現に向け、お客さま一人ひとりとの接点づくりの強化を目指す。
            </p>
          </BusinessScription>
          <img style={{ marginTop: '35px' }} src="/images/business_model_72.png" />

          <BusinessSupay>
            <BusinessSupayPaytype>
              <BusinessSupayPaytypeIcon>
                <a href="https://apps.apple.com/jp/app/trial公式アプリ-trial-トライアルプラス/id6746149916" target="_blank" rel="noreferrer">
                  <img src="/images/icon_appstore-download.webp" />
                </a>
              </BusinessSupayPaytypeIcon>
              <BusinessSupayPaytypeIcon>
                <a href="https://play.google.com/store/apps/details?id=jp.co.trial_net.trialapp.and&pcampaignid=web_share" target="_blank" rel="noreferrer">
                  <img src="/images/icon_googleplay-download.webp" />
                </a>
              </BusinessSupayPaytypeIcon>
            </BusinessSupayPaytype>
          </BusinessSupay>

          <BusinessTitle>長期的な成長に向けた戦略</BusinessTitle>
          <BusinessScription>
            <p style={{ fontSize: '18px', lineHeight: '30px', fontWeight: 'normal' }}>
              当中期経営計画においては、西友のPMIを着実に推進し、シナジー創出を軸としたキャッシュ創出力の向上によって財務健全性を高めるとともに、次世代フォーマットの成功モデルの確立など、2030年６月期以降の成長基盤を構築。
            </p>
          </BusinessScription>
          <img style={{ marginTop: '35px' }} src="/images/business_model_70.png" />

        </BusinessSection>
      </TitleLayout>
    </>
  )
}

const CompanyMain = styled.div`
  width: 1040px;
  margin: 0 auto;
  padding: 98px 0 130px;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 70px;
  }
`

const BusinessSection = styled.div`
  width: 1040px;
  margin: 0 auto;
  padding: 30px 0 130px;
  img {
    width: 100%;
  }
  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 70px;
  }
`

const BusinessTitle = styled.div`
  width: 100%;
  height: 60px;
  line-height: 58px;    
  font-size: 32px;
  font-weight: bold;
  text-indent: 10px;
  color: #FFF;
  margin-top: 150px;
  background: ${theme.colors.trialBlue};
  @media screen and (max-width: 1047px) {
    font-size: 17px;
    height: 40px;
    line-height: 38px;
    margin-top: 100px;
  }
`

const BusinessImgTitle = styled.img`
  margin-top: 150px;
  @media screen and (max-width: 1047px) {
    margin-top: 50px;
  }
`

const BusinessScription = styled.div`
  margin-top: 30px;
  font-size: 26px;
  line-height: 30px;
  font-weight: bold;
  span {
    margin-right: 8px;
  }
  p {
    margin-top: 10px;
    font-size: 20px;
  }
  @media screen and (max-width: 1047px) {
    font-size: 16px;
    line-height: 18px;
    margin-top: 12px;
    span {
      margin-right: 5px;
    }
    p {
      font-size: 14px !important;
    }
  }
`

const BusinessMap = styled.div`
  margin-top: 30px;
  position: relative;
  @media screen and (max-width: 1047px) {
    width: 100% !important;
    max-width: 580px;
    margin: 20px auto 0;
  }
`

const BusinessSupay = styled.div`
  width: 100%;
  
  @media screen and (max-width: 1047px) {
    max-width: 580px;
    margin: 0 auto;
  }
`

const BusinessSupayPaytype = styled.div`
  display: flex;
  background: #9fb5d7;
  padding: 20px;
  gap: 10px;
  justify-content: center;
  width: fit-content;
  margin: 20px auto 0;
  @media screen and (max-width: 767px) {
    padding: 5px;
  }
`

const BusinessSupayPaytypeIcon = styled.div`
  img {
    width: auto !important;
    height: 57px;
  }
  @media screen and (max-width: 767px) {
    img {
      height: 35px !important;
    }
  }
`

const BusinessRemark = styled.div`
  font-size: 11px;
  margin-top: 10px;
  line-height: 16px;
  @media screen and (max-width: 1047px) {
    font-size: 8px;
    line-height: 12px;
  }
`